import { useCallback, useEffect, useRef, useState } from "react";
import { mapKpis } from "../adapters/dashboardAdapter";
import secretariaDashboardService from "../services/secretariaDashboardService";

const emptyState = {
  kpis: [],
  operativo: { kpis: [], funnel: [], funnelMonthly: [] },
  academico: { kpis: [], ocupacion: [], proximas: [] },
  lastUpdate: null,
};

export function useSecretariaDashboardData() {
  const [state, setState] = useState(emptyState);
  const [loading, setLoading] = useState(false);
  const mountedRef = useRef(true);

  const fetchDashboard = useCallback(async () => {
    setLoading(true);
    try {
      const payload = await secretariaDashboardService.fetch();
      if (!mountedRef.current) return;

      setState({
        kpis: mapKpis(payload?.kpis || []),
        operativo: payload?.operativo || emptyState.operativo,
        academico: payload?.academico || emptyState.academico,
        lastUpdate: payload?.lastUpdate || null,
      });
    } catch (err) {
      console.error("Error cargando dashboard secretaria", err);
      if (!mountedRef.current) return;
      setState((prev) => ({ ...prev, lastUpdate: null }));
    } finally {
      if (mountedRef.current) {
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    mountedRef.current = true;
    fetchDashboard();
    return () => {
      mountedRef.current = false;
    };
  }, [fetchDashboard]);

  return { ...state, loading, fetchDashboard };
}

export default useSecretariaDashboardData;
